import { getOfferIdFromPolicyNo } from '@zurich/api/contract';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
export const useGetOfferIdByPolicyNo = (policyNo) => {
    const { t } = useTranslation();
    return useApiQuery({
        request: getOfferIdFromPolicyNo,
        params: { vars: { policyNo: policyNo ?? '' } },
        options: {
            errorText: t('contract:errors.useGetOfferIdByPolicyNo'),
        },
        queryOptions: {
            staleTime: 1000 * 60 * 5,
            retry: 3, // retry tree times
            enabled: !!policyNo,
        },
    });
};
